import React, { useEffect, useRef, useState } from 'react'
import Button from '@mui/material/Button';
import { useFormik } from "formik";
import * as Yup from "yup";
import { Box, Checkbox, Chip, Divider, FormControl, FormHelperText, InputLabel, ListItemText, MenuItem, Select, Stack, TextField, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import CommentDrawer from '../Common/Drawer';
import { createClient, updateClient } from '../../store/clientSlice';
import _ from 'lodash';
import PhoneInput from 'react-phone-input-2';


export default function ClientForm({ getClients, setPage, page, title, clientModal, setClientModal, resetTrigger, selectedClient = null }) {
    const dispatch = useDispatch();
    const [isButtonDisabled, setIsButtonDisabled] = React.useState();
    const industries = useSelector((state => state.industryReducer.industryList))
    const validationSchema = Yup.object({
        name: Yup.string().required("Name is required"),
        email: Yup.string()
            .required("Email is required")
            .matches(
                /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                "Enter a valid email address"
            ),
        industry_ids: Yup.array()
            .of(Yup.string())
            .min(1, "At least one industry must be selected"),
        contact: Yup.string()
            .matches(/^\+?(\d.*){10,}$/, 'Phone number is not valid')
            .trim(),
    });
    const selectRef = useRef(null);


    const formik = useFormik({
        initialValues: {
            email: "",
            name: "",
            contact: "",
            business: "",
            description: "",
            industry_ids: []
        },
        validationSchema: validationSchema,
        onSubmit: async (values) => {
            console.log("submit form", values);
            values.industry_ids = values.industry_ids?.filter((item) => item !== "all")
            setClientModal(false);
            if (selectedClient) {
                values.id = selectedClient.uuid;
                dispatch(updateClient(values)).then((res) => {
                    getClients()
                })
            } else {
                dispatch(createClient(values)).then(() => {
                    if (page) {
                        setPage(0)
                    } else {
                        getClients()
                    }
                })
            }
        },
    });

    useEffect(() => {
        if (selectedClient?.email && clientModal) {
            const selectedIndustries = selectedClient.industries.map((ele) => ele.industry.id)
            const isAll = _.isEqual([...selectedIndustries].sort(), [...allIndustryIds].sort())

            console.log("selectedClient.industries", selectedIndustries.isAll);

            formik.setValues({
                email: selectedClient.email || "",
                name: selectedClient.name || "",
                contact: selectedClient.contact || "",
                business: selectedClient.business || "",
                description: selectedClient.description || "",
                industry_ids: isAll ? ["all", ...selectedIndustries] : selectedIndustries || [],
            });
        } else {
            formik.resetForm();
        }
    }, [selectedClient, clientModal, resetTrigger]);

    useEffect(() => {

        if (selectedClient) {
            const industries = selectedClient?.industries?.map((ele) => ele.industry.id);
            const disabled = JSON.stringify({
                email: formik.values.email,
                contact: formik.values.contact,
                business: formik.values.business,
                name: formik.values.name,
                description: formik.values.description,
                industry_ids: formik.values.industry_ids.filter((ele) => ele !== "all")
            }) === JSON.stringify({
                email: selectedClient.email,
                contact: selectedClient.contact,
                business: selectedClient.business,
                name: selectedClient.name,
                description: selectedClient.description,
                industry_ids: industries
            });

            setIsButtonDisabled(disabled)
        }


    }, [selectedClient, formik.values])
    const allOptionId = 'all';
    const allOptionLabel = 'All';
    const allIndustryIds = industries?.map((ele) => ele.id);
    return (
        <CommentDrawer open={clientModal} setOpen={setClientModal}>
            <Box className=" position-relative h-100">
                <form onSubmit={formik.handleSubmit} >
                    <Box>
                        <Typography variant="h6" gutterBottom className='p-3'>
                            {title}
                        </Typography>
                    </Box>
                    <Divider />
                    <Box className='px-3 role-form-scroller'>
                        <TextField
                            fullWidth
                            required
                            id="name"
                            name="name"
                            label="Name"
                            margin="normal"
                            type="text"
                            className='mb-1'
                            variant="outlined"
                            value={formik.values.name}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.touched.name && Boolean(formik.errors.name)}
                            helperText={formik.touched.name && formik.errors.name}
                        />
                        <TextField
                            fullWidth
                            required
                            id="email"
                            name="email"
                            label="Email"
                            className='mb-1'
                            margin="normal"
                            onChange={(e) => {
                                const lowerCaseEmail = e.target.value.toLowerCase();
                                formik.setFieldValue("email", lowerCaseEmail);
                            }}
                            type="email"
                            variant="outlined"
                            value={formik.values.email}
                            // onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.touched.email && Boolean(formik.errors.email)}
                            helperText={formik.touched.email && formik.errors.email}
                        />
                        <PhoneInput
                            country={'us'}
                            value={formik.values.contact}
                            onChange={(value, countryData, e, formattedValue) => {
                                formik.setFieldValue('contact', formattedValue);
                            }}
                            placeholder="Enter phone number"
                            inputProps={{
                                name: 'contact',
                                required: false,
                                autoFocus: false,
                                onBlur: formik.handleBlur, // Important to trigger validation on blur
                            }}
                            className="mt-3 mb-1"
                            inputStyle={{
                                width: '100%',

                                height: '55px',
                                borderRadius: '4px',
                                backgroundColor: '#FAFBF8',
                                border: formik.touched.contact && formik.errors.contact
                                    ? '1px solid #dc3545'
                                    : '1px solid #ccc',
                            }}

                        />
                        <TextField
                            fullWidth
                            className="mt-3 mb-3"
                            id="business"
                            name="business"
                            label="Business"
                            margin="normal"
                            type="text"
                            variant="outlined"
                            value={formik.values.business}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}

                        />
                        <FormControl fullWidth className="mt-1 mb-1" required error={formik.touched.industry_ids && Boolean(formik.errors.industry_ids)}>
                            <InputLabel id="industry_ids">Industry</InputLabel>
                            <Select
                                labelId="industry_ids"
                                id="industry_ids"
                                multiple
                                name="industry_ids"
                                label="Industry"
                                value={formik.values.industry_ids}
                                ref={selectRef}
                                onChange={(event) => {
                                    const value = event.target.value;

                                    const isAllSelected = formik?.values?.industry_ids?.includes(allOptionId);
                                    const justClickedAll = value.includes(allOptionId) && !isAllSelected;
                                    const justUnclickedAll = !value.includes(allOptionId) && isAllSelected;
                                    console.log("isAllSelected", isAllSelected);
                                    console.log("justClickedAll", justClickedAll);
                                    console.log("justUnclickedAll", justUnclickedAll);


                                    if (justClickedAll) {
                                        formik.setFieldValue('industry_ids', [allOptionId, ...allIndustryIds]);

                                    } else if (justUnclickedAll) {
                                        formik.setFieldValue('industry_ids', []);
                                    } else {
                                        const filtered = value.filter(val => val !== allOptionId);

                                        if (filtered?.length === allIndustryIds?.length) {
                                            formik.setFieldValue('industry_ids', [allOptionId, ...filtered]);
                                        } else {
                                            formik.setFieldValue('industry_ids', filtered);
                                        }
                                    }
                                }}
                                MenuProps={{
                                    PaperProps: {
                                        className: "mui-select-menu",
                                    }
                                }}
                                onBlur={formik.handleBlur}
                                renderValue={(selected) => (
                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }} className="multi-selection-box-wrapper">
                                        {selected.map((id) => {
                                            const selectedIndustry = industries.find((ele) => ele?.id === id);
                                            console.log("selectedIndustry", selectedIndustry);

                                            return (
                                                selectedIndustry && <Chip
                                                    className="role-permission mr-2"
                                                    key={id}
                                                    label={selectedIndustry?.title}
                                                    onMouseDown={(event) => {
                                                        event.stopPropagation();
                                                    }}
                                                    onDelete={(event) => {
                                                        const updatedIndustries = selected.filter((selectedId) => selectedId !== id);
                                                        console.log("onDelete called", updatedIndustries);
                                                        formik.setFieldValue('industry_ids', updatedIndustries);
                                                        if (updatedIndustries.length === 0 && selectRef.current) {
                                                            const selectTrigger = selectRef.current.querySelector('[role="button"]');
                                                            selectTrigger?.blur(); // Make sure it's the actual button DOM element
                                                        }
                                                    }}
                                                />
                                            );
                                        })}
                                    </Box>
                                )}
                            >
                                {(!industries || industries?.length === 0) && (
                                    <MenuItem disabled color="primary">
                                        No industries found.
                                    </MenuItem>
                                )}
                                {industries?.length && <MenuItem key={allOptionId} value={allOptionId}>
                                    <Checkbox checked={formik.values.industry_ids?.includes(allOptionId)} />
                                    <ListItemText primary={allOptionLabel} />
                                </MenuItem>}
                                {industries?.length &&
                                    industries.map((ele) => {

                                        { console.log("industries", industries) }
                                        return (<MenuItem key={ele.id} value={ele.id}>
                                            <Checkbox
                                                checked={formik.values.industry_ids.includes(ele.id)}
                                            />
                                            <ListItemText primary={ele.title} />
                                        </MenuItem>)
                                    })}
                            </Select>
                            {formik.touched.industry_ids && formik.errors.industry_ids && (
                                <FormHelperText className='text-danger'>{formik.errors.industry_ids}</FormHelperText>
                            )}
                        </FormControl>
                        <TextField
                            fullWidth
                            className="mt-3 mb-3"
                            id="description"
                            name="description"
                            label="Description"
                            margin="normal"
                            multiline
                            rows={3}
                            type="text"
                            variant="outlined"
                            value={formik.values.description}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}

                        />
                    </Box>
                    <Box className="drawer-footer m-3">
                        <Button
                            type="button"
                            variant="outlined"
                            color="primary"
                            onClick={() => setClientModal(false)}
                            className="mt-2 mr-2"
                        >
                            Cancel
                        </Button>
                        <Button
                            type="submit"
                            variant="contained"
                            color="primary"
                            className="mt-2"
                            disabled={selectedClient ? (isButtonDisabled || !formik.isValid) : !(formik.dirty && formik.isValid)}
                        >
                            Save
                        </Button>
                    </Box>
                </form>
            </Box>
        </CommentDrawer>
    );
}